(function () {
  var STORAGE_KEY = 'rbk-recently-viewed';

  // Same Storefront API token/endpoint card-product.liquid's sibling
  // features (collection-product-swatches.liquid, color-swatch_product.
  // liquid) already use client-side elsewhere in this theme — reused here
  // rather than introduced fresh, since /products/{handle}.js (the REST
  // endpoint this used to call) has no metafields at all. It can't supply
  // the "Gender • Activity" subtitle line, though: custom.gender and
  // custom.reebok_sports both come back null via this API regardless of
  // query shape — neither metafield definition has Storefront API access
  // enabled in Shopify Admin, only Liquid's own unrestricted access
  // (confirmed directly against this store). That subtitle is fetched
  // separately below, via Section Rendering instead.
  var STOREFRONT_TOKEN = '3b94ea12d1444cf524c8d09d6567c97b';
  var STOREFRONT_ENDPOINT = '/api/2024-07/graphql.json';

  function readHandles() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (err) {
      return [];
    }
  }

  function writeHandles(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (err) {
      // localStorage unavailable (private browsing, quota, disabled) —
      // recently viewed just won't persist; nothing else depends on it.
    }
  }

  // Moves the current handle to the front (or inserts it) rather than
  // appending, so re-visiting a product bumps it back to "most recent"
  // instead of leaving a stale, older entry sitting in the list too.
  function recordView(handle, maxProducts) {
    if (!handle) return;
    var handles = readHandles().filter(function (existing) {
      return existing !== handle;
    });
    handles.unshift(handle);
    if (handles.length > maxProducts) {
      handles = handles.slice(0, maxProducts);
    }
    writeHandles(handles);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  // Real markup (site's money_format, dirham SVG included) is cloned from
  // whatever price the current page already rendered server-side via
  // Liquid's `| money` — there's no way to run that filter from JS, and
  // hardcoding a second copy of the icon's SVG path here would drift out
  // of sync with it. Falls back to plain "amount" text (no currency
  // symbol at all, not even "AED") only if the page has no price
  // anywhere to copy from, which shouldn't happen in practice.
  var dirhamIconHtml = (function () {
    var icon = document.querySelector('.uae-dirham-icon');
    return icon ? icon.outerHTML : '';
  })();

  function formatMoney(amount) {
    return '<span class="currency-with-amount">' + dirhamIconHtml + amount.toFixed(2) + '</span>';
  }

  // Builds one <li> the same shape SliderComponent (global.js) expects —
  // [id^="Slide-"], since it re-scopes to that selector whenever this
  // grid's content changes.
  function buildCardHtml(product, slideIndex) {
    // Sale price first, compare-at (struck-through) price second — matches
    // the Discover row's own price.liquid order (flex-reversed in CSS,
    // see reebok-discover.css), so both rows read the same way.
    var priceHtml = formatMoney(product.price);
    if (product.compareAtPrice && product.compareAtPrice > product.price) {
      priceHtml =
        priceHtml + ' <s class="recently-viewed-card__compare-price">' + formatMoney(product.compareAtPrice) + '</s>';
    }

    var subtitleHtml = '';
    if (product.subtitle) {
      // Same class as card-product.liquid's own subtitle span, reusing
      // its existing typography instead of duplicating it here.
      subtitleHtml =
        '<span class="rbk-card__subtitle caption-large light">' + escapeHtml(product.subtitle) + '</span>';
    }

    return (
      '<li id="Slide-recently-viewed-' +
      slideIndex +
      '" class="grid__item slider__slide">' +
      '<a href="' +
      escapeHtml(product.url) +
      '" class="recently-viewed-card">' +
      '<span class="recently-viewed-card__media">' +
      '<img src="' +
      escapeHtml(product.image) +
      '" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy" class="recently-viewed-card__img">' +
      '</span>' +
      '<span class="recently-viewed-card__title">' +
      escapeHtml(product.title) +
      '</span>' +
      '<span class="recently-viewed-card__price">' +
      priceHtml +
      '</span>' +
      subtitleHtml +
      '</a>' +
      '</li>'
    );
  }

  var PRODUCT_QUERY =
    'query RecentlyViewedProduct($handle: String!) {' +
    '  productByHandle(handle: $handle) {' +
    '    title' +
    '    handle' +
    '    featuredImage { url }' +
    '    priceRange { minVariantPrice { amount } }' +
    '    compareAtPriceRange { maxVariantPrice { amount } }' +
    '  }' +
    '}';

  function fetchProductData(handle) {
    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: PRODUCT_QUERY, variables: { handle: handle } }),
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (json) {
        var p = json && json.data && json.data.productByHandle;
        if (!p) return null;

        var price = parseFloat(p.priceRange.minVariantPrice.amount);
        var compareAtPrice = p.compareAtPriceRange
          ? parseFloat(p.compareAtPriceRange.maxVariantPrice.amount)
          : null;

        return {
          title: p.title,
          url: '/products/' + p.handle,
          image: p.featuredImage ? p.featuredImage.url : '',
          price: price,
          compareAtPrice: compareAtPrice,
        };
      })
      .catch(function () {
        return null;
      });
  }

  // sections/recently-viewed-subtitle.liquid renders just the "Gender •
  // Activity" line via Liquid, which has full metafield access regardless
  // of Storefront API visibility settings — resolving `product` from the
  // URL path (not a query string) rather than passing the handle as a
  // param, since request.query_string is documented elsewhere in this
  // feature (recently-viewed-products.liquid) as unreliable for a
  // brand-new section even against the live theme.
  function fetchSubtitle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=recently-viewed-subtitle')
      .then(function (res) {
        return res.ok ? res.text() : '';
      })
      .then(function (html) {
        var match = /<div id="RecentlyViewedSubtitle">([^<]*)<\/div>/.exec(html);
        return match ? match[1] : '';
      })
      .catch(function () {
        return '';
      });
  }

  function fetchProduct(handle) {
    return Promise.all([fetchProductData(handle), fetchSubtitle(handle)]).then(function (results) {
      var product = results[0];
      if (!product) return null;
      product.subtitle = results[1];
      return product;
    });
  }

  function initRecentlyViewed(root) {
    var currentHandle = root.dataset.currentHandle;
    var maxProducts = parseInt(root.dataset.maxProducts, 10) || 12;
    var slider = root.querySelector('.discover__slider');
    var grid = root.querySelector('.discover__grid');
    if (!slider || !grid) return;

    // Recorded before filtering it back out of what gets displayed below —
    // otherwise this page's own product would never make it into the list
    // shown on the NEXT product page visited.
    recordView(currentHandle, maxProducts);

    var handles = readHandles().filter(function (handle) {
      return handle !== currentHandle;
    });
    if (!handles.length) return;

    Promise.all(handles.map(fetchProduct))
      .then(function (products) {
        var cardsHtml = products
          .filter(Boolean)
          .map(function (product, index) {
            return buildCardHtml(product, index + 1);
          })
          .join('');

        if (!cardsHtml) return;

        grid.innerHTML = cardsHtml;
        slider.hidden = false;
        if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        }
      })
      .catch(function (err) {
        console.error('[recently-viewed] Failed to load recently viewed products:', err);
      });
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(initRecentlyViewed);
})();
